<template>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        center
        class="dialog-container"
        width="500px">
        <div slot="title" class="title">
            督办
        </div>
        <div class="form-content padding-lr">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="ruleForm" label-width="0px">
                <el-form-item label=""
                              prop="due_date">
                    <el-date-picker
                        v-model="ruleForm.due_date"
                        placeholder="督办终止时间"
                        style="width: 100%;"
                        type="date"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="btn-box" >
                <div class="btn" @click="submitForm('ruleForm')">确认督办</div>
                <div class="btn cancel" @click="handleClose">取消操作</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import {scrollIntoView} from "@/utils/utils";
import {dubanWarning} from "@/api/admin";

export default {
    name: "dubanRiskDialog",
    data() {
        return {
            ruleForm: {
                due_date:''
            },
            rules: {
                due_date: [
                    {required: true, message: '请选择', trigger: 'blur'}
                ],
            }
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: ''
        },
    },
    computed:{

    },
    components: {},
    created() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitInfo()
                } else {
                    scrollIntoView(this, validates)
                }
            });
        },

        async submitInfo() {
            let _data = await dubanWarning(
                this.id,
                this.ruleForm.due_date,
                this.ruleForm.cailiao
            );
            if (_data.status == 200) {
                this.$message.success(_data.msg);
                this.$emit('handleClose', true)
            } else {
                this.$message.error(_data.msg);
            }
        },
        handleClose() {
            this.$emit('handleClose', false)
        }
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                this.$refs.ruleForm?.resetFields()
            }
        }
    },
    filters: {}
}
</script>

<style lang="scss" scoped>
.title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
}

.form-content {
    width: 100%;

    .title-flex {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 20px;

        b {
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            margin-right: 10px;
        }
    }


    .width {
        width: 400px;
    }

    .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 30px 0;

        .btn {
            width: 180px;
            height: 40px;
            background-image: linear-gradient(0deg,
                #2791ff 0%,
                #81b6ff 100%);
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            letter-spacing: 1px;
            color: #ffffff;
            cursor: pointer;

            &.cancel {
                width: 180px;
                height: 40px;
                background: #f0f2f6;
                border-radius: 20px;
                border: solid 1px #c1c3c7;
                color: #9da0a7;
                margin-left: 20px;
            }
        }
    }

    .add {
        width: 24px;
        cursor: pointer;
    }


    .inp {
        width: 100%;
    }

    .tips {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        background-color: #fef0ef;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
        color: #f34336;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 16px;

        i {
            font-size: 20px;
            color: #f34336;
            margin-right: 4px;
        }

        &.width {
            width: 160px;
        }
    }

    .look {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        border: 1px solid #2791ff;
        color: #2791ff;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
        border-radius: 4px;

    }

    .mt15 {
        margin-top: 15px;
    }

    .btnUp {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        margin-left: 10px;
        background-image: linear-gradient(90deg,
            #2791ff 0%,
            #81b6ff 100%);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;

        i {
            font-size: 20px;
            color: #ffffff;
            margin-right: 5px;
            font-weight: 100;
        }
    }
}

.title-box {
    width: 100%;
    height: 60px;
    border-bottom: solid 2px #e3e7f0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;

        img {

        }

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 5px;
        }
    }
}
</style>


